module.exports = __webpack_public_path__ + "static/media/Back-Of-Hand(L) v2.5814db3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Back-Of-Hand(L) v2.jpg
// module id = 411
// module chunks = 0